import { FaqData } from "./faq-data-types";

export const tailrowFaqData:FaqData = [
  {
    id: 1,
    question: "Why don’t I see my policies?",
    answer: [
      "If you do not see your policies after logging in, you may have signed in using an email address that is not associated with your policy.",
      "You can call us at 844-954-1110 or email us at customerservice@tailrow.com to verify and update the email address linked to your policy.",
    ],
    links: [
      {
        type: "phone",
        identifier: "844-954-1110",
        href: "tel:8449541110",
      },
      {
        type: "email",
        identifier: "customerservice@tailrow.com",
        href: "mailto:customerservice@tailrow.com",
      },
    ],
  },
  {
    id: 2,
    question: "How do I update the email associated with my policy?",
    answer: [
      "To update the email address associated with your policy, you can call us at 844-954-1110 or email us at customerservice@tailrow.com.",
      "Once your email is updated in our system, you will be able to view your policies in the app using the updated email address.",
    ],
    links: [
      {
        type: "phone",
        identifier: "844-954-1110",
        href: "tel:8449541110",
      },
      {
        type: "email",
        identifier: "customerservice@tailrow.com",
        href: "mailto:customerservice@tailrow.com",
      },
    ],
  },
  {
    id: 3,
    question: "I forgot my password. How do I reset it?",
    answer:
      "You can reset or change your password from the Reset Password option in the Profile section.",
    links: [
      {
        type: "navigation",
        identifier: "Reset Password",
        href: "Reset Password",
      },
    ],
  },
  {
    id: 4,
    question: "How do I view or download my policy documents?",
    answer:
      "You can access your policy documents from the Docs tab. Select the document you would like to view, then tap the Download button to download or share the document.",
  },
];
